import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as commonActions from "../../../../actions/common.actions";
import * as projectActions from "../../../../actions/project.actions";
import * as skillsActions from "../../../../actions/skills.actions";

import ProjectDetail from "../components/ProjectDetail";

const rejectedHeader = () => ({
  color: "grey",
  title: "This Project has Been Rejected by The Second Shift",
  text: (
    <span>
      If you believe this was done in error, please{" "}
      <b>
        <a href="https://thesecondshift.com/contact-us" target="_blank">
          contact us
        </a>
      </b>
      .
    </span>
  )
});

class ProjectDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: null
    };
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.projectActions.getPitchesByProjectId(
      this.props.match.params.projectId
    );
    this.props.projectActions.getStatus();
    this.props.skillsActions.fetchSkills();
  }

  countHired = pitches => {
    var totalHired = 0;

    pitches.forEach(pitch => {
      if (pitch.accepted) {
        totalHired++;
      }
    });

    return totalHired;
  };

  countSelected = pitches => {
    var total = 0;

    pitches.forEach(pitch => {
      if (pitch.accepted === null) {
        total++;
      }
    });

    return total;
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.pitches !== nextProps.pitches) {
      const projectId = this.props.match.params.projectId;
      const pitches = nextProps.pitches;

      const subHeader = {
        items: [
          {
            caption: `Project Detail`,
            url: `/company/project/${projectId}`
          },
          {
            caption: `Candidates (${this.countSelected(pitches)})`,
            url: `/company/project/${projectId}/candidates`
          },
          {
            caption: `Selected (${this.countHired(pitches)})`,
            url: `/company/project/${projectId}/hired`
          }
        ],
        activeItem: 0,
        track: true
      };

      this.props.commonActions.setSubHeader(subHeader);
    }
  }

  componentDidUpdate(prevState) {
    this.setHeaderBar(prevState);
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    let headerBar = {};

    if (status) {
      switch (status) {
        case "rejected":
          headerBar = rejectedHeader();
          break;
      }
    }

    if (prevState.status && status !== prevState.status) {
      this.props.commonActions.setHeaderBar(headerBar);
      this.setState({ status });
    }
  }

  render() {
    return this.props.project ? (
      <ProjectDetail
        project={this.props.project}
        skills={this.props.skills.data}
      />
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    project: state.project.data.data,
    skills: state.skills.skills,
    pitches: state.project.pitches
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch),
    skillsActions: bindActionCreators(skillsActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectDetailContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/containers/ProjectDetailContainer.js